import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaPlaylistComponent } from './media-playlist/media-playlist.component';
import { VideoGalleryComponent } from './video-gallery/video-gallery.component';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [MediaPlaylistComponent, VideoGalleryComponent],
  exports: [MediaPlaylistComponent, VideoGalleryComponent],
  imports: [CommonModule, PipesModule, FGBSharedModule],
})
export class MediaPlayerModule {}
